import { Modal } from 'antd';

type DeleteConfirmModalProps = {
  open: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
  deleteLoading: boolean;
};

const DeleteConfirmModal = ({
  open,
  onCancel,
  onConfirm,
  deleteLoading,
}: DeleteConfirmModalProps) => {
  return (
    <Modal
      open={open}
      title="Are you sure?"
      onOk={onConfirm}
      confirmLoading={deleteLoading}
      onCancel={onCancel}
      okText="Delete"
      cancelText="Cancel"
    >
      Do you want to delete this floor plan?
    </Modal>
  );
};

export default DeleteConfirmModal;
